import React from "react";

/** Bootstrap form family — FormGroup, Input, FormCheckbox, FormSelect. */

export const Form = ({ className = "", style, children, ...rest }) => (
  <form className={className || undefined} style={style} {...rest}>
    {children}
  </form>
);

export const FormGroup = ({ className = "", style, children, ...rest }) => (
  <div className={["form-group", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </div>
);

/** Replaces shards-react FormInput. Renders a Bootstrap form-control input. */
export const FormInput = ({ className = "", size, style, ...rest }) => {
  const cls = ["form-control", size && `form-control-${size}`, className].filter(Boolean).join(" ");
  return <input className={cls} style={style} {...rest} />;
};

/** Replaces shards-react FormTextarea. Renders a Bootstrap form-control textarea. */
export const FormTextarea = ({ className = "", size, plaintext = false, style, ...rest }) => {
  const cls = [
    plaintext ? "form-control-plaintext" : "form-control",
    size && `form-control-${size}`,
    className,
  ].filter(Boolean).join(" ");
  return <textarea className={cls} style={style} {...rest} />;
};

/** Replaces shards-react FormCheckbox.
 *  - With toggle prop: renders shards custom-toggle (switch look)
 *  - Without toggle: renders Bootstrap custom-checkbox
 *  - Outer wrapper is <label> to match shards HTML structure exactly (CSS ::before/::after, click area)
 */
export const FormCheckbox = ({ id, checked, onChange, disabled = false, toggle = false, small = false, inline = false, className = "", style, children }) => {
  const uid = id || `fc-${Math.random().toString(36).slice(2, 8)}`;
  const outerCls = [
    "custom-control",
    toggle ? "custom-toggle" : "custom-checkbox",
    toggle && small && "custom-toggle-sm",
    inline && "custom-control-inline",
    className,
  ].filter(Boolean).join(" ");
  return (
    <label className={outerCls} style={style}>
      <input
        id={uid}
        type="checkbox"
        className="custom-control-input"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label className="custom-control-label" htmlFor={uid} aria-hidden="true" />
      <span className="custom-control-description">{children}</span>
    </label>
  );
};

/** Replaces shards-react FormSelect. */
export const FormSelect = ({ className = "", size, style, children, ...rest }) => {
  const cls = ["custom-select", size && `custom-select-${size}`, className].filter(Boolean).join(" ");
  return (
    <select className={cls} style={style} {...rest}>
      {children}
    </select>
  );
};

/** Bootstrap input-group family — InputGroup, InputGroupAddon, InputGroupText. */
export const InputGroup = ({ seamless = false, className = "", style, children, ...rest }) => {
  const cls = ["input-group", seamless && "input-group-seamless", className].filter(Boolean).join(" ");
  return (
    <div className={cls} style={style} {...rest}>
      {children}
    </div>
  );
};

export const InputGroupAddon = ({ type = "prepend", className = "", style, children, ...rest }) => {
  const cls = [`input-group-${type}`, className].filter(Boolean).join(" ");
  return (
    <div className={cls} style={style} {...rest}>
      {children}
    </div>
  );
};

export const InputGroupText = ({ className = "", style, children, ...rest }) => (
  <span className={["input-group-text", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </span>
);

/** Bootstrap list-group family — ListGroup, ListGroupItem. */
export const ListGroup = ({ flush = false, small = false, className = "", style, children, ...rest }) => {
  const cls = ["list-group", flush && "list-group-flush", small && "list-group-sm", className].filter(Boolean).join(" ");
  return <ul className={cls} style={style} {...rest}>{children}</ul>;
};

export const ListGroupItem = ({ className = "", style, children, ...rest }) => (
  <li className={["list-group-item", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </li>
);
